import { useMediaQuery } from '@material-ui/core';
import { createContext, useContext, useMemo } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var Context = /*#__PURE__*/createContext({});
function useBreakpoint(breakpoint) {
  return useMediaQuery(theme => theme.breakpoints.only(breakpoint));
}
export function ResponsiveContextProvider(_ref) {
  var {
    children,
    defaultBreakpoint
  } = _ref;
  var isXS = useBreakpoint('xs');
  var isSM = useBreakpoint('sm');
  var isMD = useBreakpoint('md');
  var isLG = useBreakpoint('lg');
  var isXL = useBreakpoint('xl');
  var breakpoint = isXS ? 'xs' : isSM ? 'sm' : isMD ? 'md' : isLG ? 'lg' : isXL ? 'xl' : defaultBreakpoint;
  var ctx = useMemo(() => ({
    breakpoint
  }), [breakpoint]);
  return /*#__PURE__*/_jsx(Context.Provider, {
    value: ctx,
    children: children
  });
}
export function useResponsiveContext() {
  return useContext(Context);
}